import { Truck } from "lucide-react";

// Shown inside the table body when there are no trucks to display.
export const TruckListEmptyState = () => (
    <div className="flex flex-col items-center justify-center gap-3 px-4 py-10 text-center">
        <div className="flex h-[52px] w-[52px] items-center justify-center rounded bg-cm-p-surface-container">
            <Truck className="h-[30px] w-[30px] text-cm-p-text-secondary" strokeWidth={1.5} />
        </div>
        <div className="flex flex-col gap-1">
            <span className="text-[18px] font-medium text-cm-p-text-primary">No trucks available</span>
            <span className="max-w-[320px] text-sm text-cm-p-text-primary">
                Check back later or try adjusting or removing some filters to see more truck updates.
            </span>
        </div>
    </div>
);
